<template>
  <div class="UploadPic">
    <Modal
      width="40%"
      v-model="isModal"
      title="选择头像"
      :loading="loading"
      :mask-closable="false"
      @on-visible-change="modalChange"
    >
      <div class="cropper-content">
        <div class="cropper">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixedBox="option.fixedBox"
            @realTime="realTime"
            @imgLoad="imgLoad"
          ></vueCropper>
        </div>
        <div
          class="show-preview"
          :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}"
        >
          <div
            :style="previews.div"
            class="preview"
          >
            <img
              :src="previews.url"
              :style="previews.img"
            >
          </div>
        </div>
      </div>
      <div class="footer-btn">
        <div class="scope-btn">
          <label
            class="btn"
            for="uploads"
          >选择图片</label>
          <input
            type="file"
            id="uploads"
            style="position:absolute; clip:rect(0 0 0 0);"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="uploadImg($event, 1)"
          >
        </div>
        <div class="upload-btn">
          <Button
            type="primary"
            style="margin-left: 46px;"
            @click="down('blob')"
          >上传头像</Button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </Modal>
  </div>
</template>
<script>
// import axios from 'axios'
// import { getToken } from '../../../common/user'
import {
  HeadPortrait
} from '../../../api/index'
export default {
  name: 'UploadPic',
  props: {
    modal: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isModal: false,
      loading: false,
      crap: false,
      previews: {},
      option: {
        img:
          'http:img1.vued.vanthink.cn/vued751d13a9cb5376b89cb6719e86f591f3.png',
        size: 1,
        full: false, // 输出原图比例截图 props名full
        outputType: 'png',
        canMove: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true
      },
      downImg: '#'
    }
  },
  watch: {
    modal (val) {
      this.isModal = val
    }
  },
  mounted () {},
  methods: {
    modalChange (val) {
      if (!val) {
        this.$emit('closeModal')
      } else {
        // this.previews = {}
        // this.option.img = ''
      }
    },
    // 实时预览函数
    realTime (data) {
      this.previews = data
    },
    down (type) {
      // event.preventDefault()
      var aLink = document.createElement('a')
      aLink.download = 'author-img'
      // 输出
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(data => {
          // this.downImg = new window.File(
          //   [data],
          //   '123',
          //   { type: data.type }
          // )
          // //            aLink.download = this.downImg;
          const formData = new FormData()
          // formData.append('img', this.downImg)
          formData.append('img', data, 'aa.txt')
          HeadPortrait(formData).then((res) => {
            if (res.code === 200) {
              this.$emit('getPic', res.data.pic)
            }
          })
          // axios({
          //   method: 'post',
          //   url: 'http://58.248.91.71:8888/hjgwebsite/avatar',
          //   data: formData,
          //   // 这里可以在header中加一些东西，比如token
          //   headers: {
          //     token: JSON.parse(getToken()).token
          //   }
          // })
          //   .then(res => {
          //     this.$emit('getPic', res.data.data.pic)
          //   })
          //   .catch(error => {
          //     console.log(error)
          //   })
          // aLink.href = window.URL.createObjectURL(data)
          // aLink.click()
        })
      } else {
        this.$refs.cropper.getCropData(data => {
          console.log(data)
          this.downImg = data
          var dt = {
            img: data
          }
          this.$emit('getPic', dt)
          // aLink.href = data
          // aLink.click()
          // 将头像图片数据发送给后台
        })
      }
    },
    uploadImg (e, num) {
      // 上传图片
      // this.option.img
      var file = e.target.files[0]
      // if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
      //   alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
      //   return false
      // }
      var reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        if (num === 1) {
          this.option.img = data
        } else if (num === 2) {
          this.example2.img = data
        }
      }
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    imgLoad (msg) {
      console.log(msg)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ivu-modal-footer {
  border-top: none;
  padding: 0px;
}
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  .cropper {
    width: 350px;
    height: 300px;
  }
  .show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    .preview {
      overflow: hidden;
      border-radius: 50%;
      border: 1px solid #cccccc;
      background: #cccccc;
      margin-left: 40px;
    }
  }
}
.footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  .scope-btn {
    width: 350px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
  }
  .upload-btn {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
  }
  .btn {
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    padding: 10px 15px;
    font-size: 12px;
    border-radius: 3px;
    color: #fff;
    background-color: #67c23a;
    border-color: #67c23a;
  }
}
</style>
